import React from "react";

// Size class mapping
const sizeClasses = {
  small: "h-8 w-8 me-0",
  default: "h-9",
  large: "h-12",
};

// Spinner component
const Spinner = ({ size = "default" }) => {
  const heightClass = sizeClasses[size] || sizeClasses.default;

  return (
    <div className={`dimmer ${heightClass} active`}>
      <div className="loader" />
      <div className="dimmer-content" />
    </div>
  );
};

export default Spinner;
